import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import FloatingButtons from './FloatingButtons';
import GoogleAnalytics from './GoogleAnalytics';
import usePageTracker from '../hooks/usePageTracker';

export default function PublicLayout() {
  usePageTracker();
  return (
    <>
      <GoogleAnalytics />
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <FloatingButtons />
    </>
  );
}
